// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3t6DN","title":"AfterBackImages_title__2uiHk","images":"AfterBackImages_images__148ze"};